import React, {memo} from 'react'
import _ from 'lodash'
import {Button, Form, Header, List, Message, Modal} from 'semantic-ui-react'
import {withErrorHandling, withHelmet, withServicesData, withMeData} from '../../hoc'
import {CodeEditor} from '../shared'
import {getPublishedOrFirstVersion, goBack} from '../../util'
import {uploadService} from '../../backend'
import {useSafeState} from '../../hook'

const _UploadContract = (
  {
    services = [],
    uploadService,
    history,
    navigate,
    mutateServices,
    mutateMe,
    basePath = '/c/services'
  }
) => {/**/
  const [state, setState] = useSafeState({
    definition: '',
    submitted: false,
    errors: {}
  })

  const validate = ({definition, errors = {}}) => {
    if (!definition) {
      errors['contract.definition.required'] = 'Definition required'
    } else {
      delete errors['contract.definition.required']
    }
    return errors
  }

  const onInputChange = (e) => {
    let updatedForm = {...state, ...{[e.target.name]: e.target.value}}
    let errors = {}
    if (state.submitted) {
      errors = validate(updatedForm)
      updatedForm = {...updatedForm, ...{errors}}
    }
    setState(updatedForm)
  }

  const onClose = () => {
    goBack(history, navigate, basePath)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const errors = validate(state)
    if (_.keys(errors).length) {
      setState({...state, ...{errors}})
      return
    }
    setState({...state, ...{submitting: true, definition: state.definition}})
    const uploaded = await uploadService(state)
    const version = getPublishedOrFirstVersion(uploaded)
    await Promise.all([
      mutateServices([...services, uploaded]),
      mutateMe()
    ])
    navigate(`${basePath}/${uploaded.id}/versions/${version.id}/environments`)
  }

  const {definition, errors, submitting} = state
  const hasDefinitionError = _.keys(errors).some((k) => k.indexOf('contract.definition') > -1)
  const hasErrors = hasDefinitionError

  return (
    <Modal open={true} closeOnDimmerClick={true} closeIcon={true} onClose={onClose} size='fullscreen' data-testid='contract-upload-upsert-modal'>
      <Header content="Upload Contract"/>
      <Modal.Content>
        <Form error={hasErrors}>
          <Form.Field error={hasDefinitionError} required>
            <label>Definition</label>
            <div data-testid='upload-contract-definition-editor'>
              <CodeEditor
                readOnly={false}
                focus={true}
                mode={definition.indexOf('{') === 0 ? 'json' : 'yaml'}
                theme='xcode'
                height='600px'
                width='100%'
                showPrintMargin={false}
                value={definition}
                editorProps={{$blockScrolling: true}}
                onChange={(value) => onInputChange({
                  target: {
                    name: 'definition',
                    value
                  }
                })}
              />
            </div>
          </Form.Field>
          <Message error data-testid='upload-contract-errors'>
            <Message.Content>
              <List bulleted>
                {
                  _.keys(errors).map((key) => (
                    <List.Item key={key}>{errors[key]}</List.Item>
                  ))
                }
              </List>
            </Message.Content>
          </Message>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} data-testid='upload-contract-cancel-button'>Cancel</Button>
        <Button primary onClick={onSubmit}
                data-testid='upload-contract-submit-button'
                loading={submitting}>Upload</Button>
      </Modal.Actions>
    </Modal>
  )
}


let UploadContract = (props) => {
  const {handleError} = props
  const history = window.history
  props = {
    ...props,
    history,
    uploadService: handleError(uploadService)
  }
  return (<_UploadContract {...props}/>)
}


UploadContract = withHelmet(UploadContract, 'Upload Contract')
UploadContract = withMeData(UploadContract)
UploadContract = withServicesData(UploadContract)
UploadContract = withErrorHandling(UploadContract)
UploadContract = memo(UploadContract)

export {_UploadContract, UploadContract}

export default UploadContract